import PropTypes from 'prop-types';

export const ExtraAttributePropType = PropTypes.shape({
  type: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  localId: PropTypes.string,
});

export const ExtraDataPropType = PropTypes.shape({
  attributes: PropTypes.arrayOf(ExtraAttributePropType),
});
